var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    enableBackground: "new 0 0 76.00 76.00",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 1,
    strokeWidth: 0.2,
    strokeLinejoin: "round",
    d: "M 38.7916,15.8334C 40.5405,15.8334 40.375,17.2511 40.375,19L 40.4832,22.422L 58.8399,27.5931L 58.0738,30.6657L 56.0774,30.168L 64.9166,47.5C 64.9166,50.5606 59.8717,53.0417 54.625,53.0417C 49.3783,53.0417 44.3333,50.5606 44.3333,47.5L 52.3887,29.2483L 40.6112,26.3118L 41.5394,53.9324C 47.6545,54.3801 52.25,56.2923 52.25,58.5833L 25.3333,58.5833C 25.3333,56.2923 29.9288,54.3801 36.0439,53.9324L 37.1289,25.4436L 23.8151,22.1241L 31.6666,40.375C 31.6666,43.4356 26.6217,45.9167 21.375,45.9167C 16.1283,45.9167 11.0833,43.4356 11.0833,40.375L 20.1264,21.2044L 18.13,20.7066L 18.8961,17.634L 37.2057,22.0007L 37.2083,19C 37.2083,17.2511 37.0427,15.8334 38.7916,15.8334 Z M 61.2191,47.5L 55.4166,33.1384L 55.4166,47.5L 61.2191,47.5 Z M 48.0308,47.5L 53.8333,47.5L 53.8333,33.1384L 48.0308,47.5 Z M 27.9691,40.3751L 22.1666,26.0135L 22.1666,40.3751L 27.9691,40.3751 Z M 14.7808,40.3751L 20.5833,40.3751L 20.5833,26.0134L 14.7808,40.3751 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.6610aeb050ddfca8b9f03c8ece54c230.svg";
export { ForwardRef as ReactComponent };